import axios from 'axios'
import { QUOTES_ENDPOINT } from 'common/backend/endpoints'

export async function generatePDF(id) {
    const endpoint = QUOTES_ENDPOINT + `/quotes/${id}/pdf`;
    const response = await axios.get(endpoint);
    return response.data;
}

export default generatePDF;
